export const RESTRICTED_SALE = "restricted";
